
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./MisSolicitudes.css";
import API from "../api";

export default function MisSolicitudes() {
  const navigate = useNavigate();

  const [solicitudes, setSolicitudes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  const [solicitudSeleccionada, setSolicitudSeleccionada] =
    useState(null);
  const [combustible, setCombustible] = useState("");
  const [alimentacion, setAlimentacion] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [guardando, setGuardando] = useState(false);

  const [mensaje, setMensaje] = useState("");
  const [liquidacionParaFacturas, setLiquidacionParaFacturas] =
    useState(null);
  const [archivosFacturas, setArchivosFacturas] = useState([]);
  const [subiendoFacturas, setSubiendoFacturas] =
    useState(false);

  // Obtener solicitudes del conductor
  const obtenerSolicitudes = async () => {
    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        throw new Error(
          "Debes iniciar sesión para consultar tus solicitudes."
        );
      }

      const respuesta = await fetch(
        `${API}/mis-solicitudes`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error ||
            "No se pudieron cargar las solicitudes."
        );
      }

      setSolicitudes(datos);
      setError("");
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    obtenerSolicitudes();
  }, []);

  // Formato de fecha
  const mostrarFecha = (fecha) => {
    if (!fecha) return "Sin fecha";

    return new Date(fecha).toLocaleDateString("es-GT");
  };

  // Formato de moneda
  const mostrarMonto = (monto) => {
    return `Q ${Number(monto).toFixed(2)}`;
  };

  // Clase para los estados
  const claseEstado = (estado) => {
    switch (estado) {
      case "Aprobada":
        return "mis-solicitudes-aprobada";
      case "Entregada":
        return "mis-solicitudes-entregada";
      case "Rechazada":
        return "mis-solicitudes-rechazada";
      case "Pendiente":
        return "mis-solicitudes-pendiente";
      default:
        return "";
    }
  };

  // Abrir formulario de liquidación
  const abrirLiquidacion = (solicitud) => {
    setSolicitudSeleccionada(solicitud);
    setLiquidacionParaFacturas(null);
    setCombustible("");
    setAlimentacion("");
    setObservaciones("");
    setArchivosFacturas([]);
    setMensaje("");
  };

  const cerrarLiquidacion = () => {
    setSolicitudSeleccionada(null);
    setMensaje("");
  };

  // Cálculo de gastos reales
  const totalGastado = Number(
    (
      Number(combustible || 0) +
      Number(alimentacion || 0)
    ).toFixed(2)
  );

  const diferencia = solicitudSeleccionada
    ? Number(
        (
          Number(solicitudSeleccionada.total_viaticos) -
          totalGastado
        ).toFixed(2)
      )
    : 0;

  // Registrar liquidación
  const registrarLiquidacion = async (e) => {
    e.preventDefault();

    if (!solicitudSeleccionada || guardando) return;

    const montoValido = (valor) => {
      return (
        valor.trim() !== "" &&
        /^\d+(\.\d{1,2})?$/.test(valor) &&
        Number.isFinite(Number(valor)) &&
        Number(valor) >= 0
      );
    };

    if (
      !montoValido(combustible) ||
      !montoValido(alimentacion)
    ) {
      setMensaje(
        "Ingresa montos válidos con máximo dos decimales."
      );
      return;
    }

// Validar cantidad de comprobantes
if (
  archivosFacturas.length < 1 ||
  archivosFacturas.length > 5
) {
  setMensaje("Selecciona entre 1 y 5 comprobantes.");
  return;
}

// Validar formatos y tamaños
const extensiones = [".jpg", ".jpeg", ".png", ".pdf"];

const archivosValidos = archivosFacturas.every((archivo) => {
  const nombre = archivo.name.toLowerCase();

  return (
    extensiones.some((ext) => nombre.endsWith(ext)) &&
    archivo.size > 0 &&
    archivo.size <= 5 * 1024 * 1024
  );
});

if (!archivosValidos) {
  setMensaje(
    "Solo se permiten archivos JPG, PNG o PDF de máximo 5 MB."
  );
  return;
}

const confirmar = window.confirm(
  "¿Deseas registrar esta liquidación y enviar sus comprobantes?"
);
    if (!confirmar) return;

    let liquidacionRegistrada = false;
    setGuardando(true);
    setMensaje("");

    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        throw new Error(
          "Tu sesión ha expirado. Inicia sesión nuevamente."
        );
      }

      const respuesta = await fetch(
        `${API}/liquidaciones`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id_solicitud:
              solicitudSeleccionada.id_solicitud,
            gasto_combustible: Number(combustible),
            gasto_alimentacion: Number(alimentacion),
            observaciones,
          }),
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error ||
            "No se pudo registrar la liquidación."
        );
      }

const idLiquidacion = datos.id_liquidacion;
liquidacionRegistrada = true;

if (!idLiquidacion) {
  setMensaje(
    "La liquidación se registró, pero no se recibió su identificador. " +
    "Actualiza la lista y utiliza Adjuntar facturas para completar el envío."
  );

  setSolicitudSeleccionada(null);
  await obtenerSolicitudes();
  return;
}

const formulario = new FormData();

archivosFacturas.forEach((archivo) => {
  formulario.append("facturas", archivo);
});

const respuestaFacturas = await fetch(
  `${API}/liquidaciones/${idLiquidacion}/comprobantes`,
  {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formulario,
  }
);

await respuestaFacturas.json();

if (!respuestaFacturas.ok) {
  setMensaje(
    "La liquidación se registró, pero no se pudieron subir " +
    "los comprobantes. Utiliza Adjuntar facturas para reintentarlo."
  );

  setSolicitudSeleccionada(null);
  await obtenerSolicitudes();
  return;
}

setSolicitudSeleccionada(null);
setArchivosFacturas([]);

setMensaje(
  "Liquidación y comprobantes enviados correctamente. " +
  "Pendiente de revisión."
);

await obtenerSolicitudes();
   } catch (err) {
  if (liquidacionRegistrada) {
    setMensaje(
      "La liquidación se registró, pero ocurrió un error al subir " +
      "los comprobantes. Utiliza Adjuntar facturas para reintentarlo."
    );

    setSolicitudSeleccionada(null);
    await obtenerSolicitudes();
  } else {
    setMensaje(err.message);
  }
} finally {
  setGuardando(false);
}
  };

  // Abrir panel de facturas
  const abrirFacturas = (solicitud) => {
    setLiquidacionParaFacturas(solicitud);
    setSolicitudSeleccionada(null);
    setArchivosFacturas([]);
    setMensaje("");
  };

  // Subir facturas
  const subirFacturas = async () => {
    if (
      !liquidacionParaFacturas ||
      subiendoFacturas
    ) {
      return;
    }

    if (
      archivosFacturas.length === 0 ||
      archivosFacturas.length > 5
    ) {
      setMensaje(
        "Selecciona entre 1 y 5 archivos."
      );
      return;
    }

    const extensionesPermitidas = [
      ".jpg",
      ".jpeg",
      ".png",
      ".pdf",
    ];

    const archivosValidos = archivosFacturas.every(
      (archivo) => {
        const nombre = archivo.name.toLowerCase();

        return (
          extensionesPermitidas.some((ext) =>
            nombre.endsWith(ext)
          ) &&
          archivo.size > 0 &&
          archivo.size <= 5 * 1024 * 1024
        );
      }
    );

    if (!archivosValidos) {
      setMensaje(
        "Solo se permiten archivos JPG, PNG o PDF de máximo 5 MB."
      );
      return;
    }

    setSubiendoFacturas(true);
    setMensaje("");

    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        throw new Error(
          "Debes iniciar sesión nuevamente."
        );
      }

      const formulario = new FormData();

      archivosFacturas.forEach((archivo) => {
        formulario.append("facturas", archivo);
      });

      const respuesta = await fetch(
        `${API}/liquidaciones/${liquidacionParaFacturas.id_liquidacion}/comprobantes`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formulario,
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error ||
            "No se pudieron subir las facturas."
        );
      }

      setMensaje(
        `${datos.cantidad} archivo(s) guardado(s) correctamente.`
      );

      setLiquidacionParaFacturas(null);
      setArchivosFacturas([]);

      await obtenerSolicitudes();
    } catch (err) {
      setMensaje(err.message);
    } finally {
      setSubiendoFacturas(false);
    }
  };

 
return (
  <div className="mis-solicitudes">

    <div className="mis-solicitudes-boton-superior">
      <button
        type="button"
        className="mis-solicitudes-volver-dashboard"
        onClick={() => navigate("/panel-conductor")}
      >
        ← Volver al Dashboard
      </button>
    </div>

    <h1>Mis solicitudes de viáticos</h1>


      <p className="mis-solicitudes-subtitulo">
        Consulta tus solicitudes, revisa su estado y
        registra las liquidaciones de los viáticos
        recibidos.
      </p>

      {/* Mensajes generales */}
      {cargando && (
        <p>Cargando solicitudes...</p>
      )}

      {error && (
        <p
          className="mis-solicitudes-error"
          role="alert"
        >
          {error}
        </p>
      )}

      {mensaje && (
        <p
          className="mis-solicitudes-mensaje"
          role="status"
        >
          {mensaje}
        </p>
      )}

      {!cargando &&
        !error &&
        solicitudes.length === 0 && (
          <div className="mis-solicitudes-tabla-contenedor">
            <p className="mis-solicitudes-vacio">
              Todavía no tienes solicitudes registradas.
            </p>
          </div>
        )}

      {/* Tabla de solicitudes */}
      {!cargando &&
        !error &&
        solicitudes.length > 0 && (
          <div className="mis-solicitudes-tabla-contenedor">
            <table className="mis-solicitudes-tabla">
              <thead>
                <tr>
                  <th>N.º</th>
                  <th>Fecha</th>
                  <th>Origen</th>
                  <th>Destino</th>
                  <th>Vehículo</th>
                  <th>Combustible</th>
                  <th>Alimentación</th>
                  <th>Total</th>
                  <th>Estado</th>
                  <th>Acción</th>
                </tr>
              </thead>

              <tbody>
                {solicitudes.map((solicitud) => (
                  <tr key={solicitud.id_solicitud}>
                    <td>
                      #{solicitud.id_solicitud}
                    </td>

                    <td>
                      {mostrarFecha(
                        solicitud.fecha_solicitud
                      )}
                    </td>

                    <td>{solicitud.origen}</td>

                    <td>{solicitud.destino}</td>

                    <td>
                      {solicitud.marca} -{" "}
                      {solicitud.vehiculo}
                    </td>

                    <td>
                      {mostrarMonto(
                        solicitud.total_combustible
                      )}
                    </td>

                    <td>
                      {mostrarMonto(
                        solicitud.total_alimentacion
                      )}
                    </td>

                    <td>
                      <span className="mis-solicitudes-monto">
                        {mostrarMonto(
                          solicitud.total_viaticos
                        )}
                      </span>
                    </td>

                    <td>
                      <span
                        className={
                          "mis-solicitudes-estado " +
                          claseEstado(solicitud.estado)
                        }
                      >
                        {solicitud.estado}
                      </span>
                    </td>

                    <td>
                      {solicitud.estado ===
                      "Entregada" ? (
                        solicitud.id_liquidacion != null ? (
                          <div>
                            <span
                              className={
                                "mis-solicitudes-estado " +
                                claseEstado(
                                  solicitud.estado_liquidacion
                                )
                              }
                            >
                              Liquidación:{" "}
                              {
                                solicitud.estado_liquidacion
                              }
                            </span>

                            {solicitud.estado_liquidacion ===
                              "Pendiente" && (
                              <div
                                style={{
                                  marginTop: "12px",
                                }}
                              >
                                <button
                                  type="button"
                                  className="mis-solicitudes-boton mis-solicitudes-boton-secundario"
                                  onClick={() =>
                                    abrirFacturas(
                                      solicitud
                                    )
                                  }
                                >
                                  Adjuntar facturas
                                </button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <button
                            type="button"
                            className="mis-solicitudes-boton mis-solicitudes-boton-primario"
                            onClick={() =>
                              abrirLiquidacion(
                                solicitud
                              )
                            }
                          >
                            Liquidar viáticos
                          </button>
                        )
                      ) : (
                        "—"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

      {/* Formulario de liquidación */}
      {solicitudSeleccionada && (
        <div className="mis-solicitudes-panel">
          <h2>
            Liquidar solicitud #
            {solicitudSeleccionada.id_solicitud}
          </h2>

          <p>
            Registra los gastos reales realizados
            durante el viaje.
          </p>

          <div className="mis-solicitudes-resumen">
            <div className="mis-solicitudes-resumen-fila">
              <span>Dinero entregado</span>
              <strong>
                {mostrarMonto(
                  solicitudSeleccionada.total_viaticos
                )}
              </strong>
            </div>
          </div>

          <form onSubmit={registrarLiquidacion}>
            <div className="mis-solicitudes-campo">
              <label htmlFor="gasto-combustible">
                Gasto real de combustible (Q)
              </label>

              <input
                id="gasto-combustible"
                type="number"
                min="0"
                step="0.01"
                placeholder="Ejemplo: 250.00"
                required
                value={combustible}
                onChange={(e) =>
                  setCombustible(e.target.value)
                }
              />
            </div>

            <div className="mis-solicitudes-campo">
              <label htmlFor="gasto-alimentacion">
                Gasto real de alimentación (Q)
              </label>

              <input
                id="gasto-alimentacion"
                type="number"
                min="0"
                step="0.01"
                placeholder="Ejemplo: 150.00"
                required
                value={alimentacion}
                onChange={(e) =>
                  setAlimentacion(e.target.value)
                }
              />
            </div>

<div className="mis-solicitudes-campo">
  <label htmlFor="facturas-liquidacion">
    Adjuntar facturas o comprobantes
  </label>

  <input
    id="facturas-liquidacion"
    type="file"
    accept=".jpg,.jpeg,.png,.pdf"
    multiple
    required
    onChange={(e) =>
      setArchivosFacturas(Array.from(e.target.files || []))
    }
  />

  <p className="mis-solicitudes-ayuda">
    Selecciona entre 1 y 5 archivos JPG, PNG o PDF.
    Máximo 5 MB por archivo.
  </p>

  {archivosFacturas.length > 0 && (
    <div className="mis-solicitudes-archivos">
      <h3>Comprobantes seleccionados</h3>
      <ul>
        {archivosFacturas.map((archivo, index) => (
          <li key={index}>{archivo.name}</li>
        ))}
      </ul>
    </div>
  )}
</div>

            {/* Resumen de gastos */}
            <div className="mis-solicitudes-resumen">
              <div className="mis-solicitudes-resumen-fila">
                <span>Total gastado</span>
                <strong>
                  {mostrarMonto(totalGastado)}
                </strong>
              </div>

              <div className="mis-solicitudes-resumen-fila">
                <span>
                  {diferencia >= 0
                    ? "Dinero sobrante"
                    : "Gasto adicional"}
                </span>

                <strong>
                  {mostrarMonto(
                    Math.abs(diferencia)
                  )}
                </strong>
              </div>
            </div>

            <div className="mis-solicitudes-campo">
              <label htmlFor="observaciones">
                Observaciones (opcional)
              </label>

              <textarea
                id="observaciones"
                rows={4}
                maxLength={2000}
                placeholder="Escribe cualquier observación relacionada con los gastos..."
                value={observaciones}
                onChange={(e) =>
                  setObservaciones(e.target.value)
                }
              />
            </div>

            <div className="mis-solicitudes-acciones">
              <button
                type="submit"
                className="mis-solicitudes-boton mis-solicitudes-boton-primario"
                disabled={guardando}
              >
                {guardando
                  ? "Envaindo..."
                  : "Enviar liquidación y comprobantes"}
              </button>

              <button
                type="button"
                className="mis-solicitudes-boton mis-solicitudes-boton-cancelar"
                onClick={cerrarLiquidacion}
                disabled={guardando}
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Panel para adjuntar facturas */}
      {liquidacionParaFacturas && (
        <div className="mis-solicitudes-panel">
          <h2>Adjuntar facturas</h2>

          <p>
            Solicitud N.º{" "}
            {liquidacionParaFacturas.id_solicitud}
          </p>

          <p>
            Selecciona las fotografías o documentos
            que respaldan los gastos de combustible
            y alimentación.
          </p>

          <div className="mis-solicitudes-campo">
            <label htmlFor="archivos-facturas">
              Seleccionar facturas
            </label>

            <input
              id="archivos-facturas"
              type="file"
              accept=".jpg,.jpeg,.png,.pdf"
              multiple
              onChange={(e) =>
                setArchivosFacturas(
                  Array.from(e.target.files || [])
                )
              }
            />
          </div>

          <p className="mis-solicitudes-ayuda">
            Formatos permitidos: JPG, PNG y PDF.
            Máximo 5 archivos de 5 MB cada uno.
          </p>

          {archivosFacturas.length > 0 && (
            <div className="mis-solicitudes-archivos">
              <h3>Archivos seleccionados</h3>

              <ul>
                {archivosFacturas.map(
                  (archivo, index) => (
                    <li key={index}>
                      {archivo.name}
                    </li>
                  )
                )}
              </ul>
            </div>
          )}

          <div className="mis-solicitudes-acciones">
            <button
              type="button"
              className="mis-solicitudes-boton mis-solicitudes-boton-primario"
              onClick={subirFacturas}
              disabled={
                subiendoFacturas ||
                archivosFacturas.length === 0
              }
            >
              {subiendoFacturas
                ? "Subiendo..."
                : "Subir facturas"}
            </button>

            <button
              type="button"
              className="mis-solicitudes-boton mis-solicitudes-boton-cancelar"
              disabled={subiendoFacturas}
              onClick={() => {
                setLiquidacionParaFacturas(null);
                setArchivosFacturas([]);
                setMensaje("");
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

  
        
      
    </div>
  );
}
